"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRichTextDescription = toRichTextDescription;
exports.findColorPickerAttributesForSelection = findColorPickerAttributesForSelection;
exports.validateColorPickerSelectionInHydratedScene = validateColorPickerSelectionInHydratedScene;
exports.collectRichTextSourcesFromScene = collectRichTextSourcesFromScene;
exports.isColorPickerValueAllowed = isColorPickerValueAllowed;
const RichTextParser_1 = require("../parser/RichTextParser");
const splitColorPickerColorTokens_1 = require("./splitColorPickerColorTokens");
/**
 * Normalize adventure rich text fields to a parsed {@link RichTextDescription}.
 */
function toRichTextDescription(input) {
    if (input === undefined || input === null) {
        return null;
    }
    if (typeof input === 'string') {
        return RichTextParser_1.RichTextParser.parseRichTextDescription(input);
    }
    return input;
}
function matchColorPicker(el, variableName, selectionTarget) {
    if (el.type !== 'color-picker' || !el.colorPickerAttributes) {
        return null;
    }
    const a = el.colorPickerAttributes;
    if (a.variable === variableName && a.selectionTarget === selectionTarget) {
        return a;
    }
    return null;
}
function getNestedRichTextElements(element) {
    const out = [];
    if (element.type === 'conditional') {
        if (Array.isArray(element.children)) {
            out.push(...element.children);
        }
        if (Array.isArray(element.elseChildren)) {
            out.push(...element.elseChildren);
        }
        return out;
    }
    if (element.type === 'inline-option' && Array.isArray(element.content)) {
        out.push(...element.content);
        return out;
    }
    if (Array.isArray(element.content)) {
        for (const item of element.content) {
            if (item && typeof item === 'object' && 'type' in item) {
                out.push(item);
            }
        }
    }
    return out;
}
function walk(elements, variableName, selectionTarget) {
    for (const el of elements) {
        const hit = matchColorPicker(el, variableName, selectionTarget);
        if (hit) {
            return hit;
        }
        const nested = walk(getNestedRichTextElements(el), variableName, selectionTarget);
        if (nested) {
            return nested;
        }
    }
    return null;
}
/**
 * Search parsed rich text fragments for a `<Color-Picker>` matching `variable` and `selectionTarget`.
 */
function findColorPickerAttributesForSelection(richTextFragments, variableName, selectionTarget) {
    for (const fragment of richTextFragments) {
        const desc = toRichTextDescription(fragment);
        if (!desc) {
            continue;
        }
        const found = walk(desc.elements, variableName, selectionTarget);
        if (found) {
            return found;
        }
    }
    return null;
}
/**
 * Collect all rich text sources on a scene (section bodies, option text, wait messages).
 */
/**
 * Find a matching `<Color-Picker>` on an interpolated (display) scene.
 */
function validateColorPickerSelectionInHydratedScene(scene, variableName, selectionTarget) {
    return findColorPickerAttributesForSelection(collectRichTextSourcesFromScene(scene), variableName, selectionTarget);
}
function collectRichTextSourcesFromScene(scene) {
    const parts = [];
    for (const section of scene.sections ?? []) {
        if (section.description !== undefined) {
            parts.push(section.description);
        }
        for (const opt of section.options ?? []) {
            if (opt.text !== undefined) {
                parts.push(opt.text);
            }
            if (opt.waitMessage !== undefined) {
                parts.push(opt.waitMessage);
            }
        }
    }
    return parts;
}
/**
 * True if `colorValue` (trimmed) exactly matches one token in the picker's `colors` attribute.
 */
function isColorPickerValueAllowed(attributes, colorValue) {
    const trimmed = colorValue.trim();
    if (!trimmed) {
        return false;
    }
    const tokens = (0, splitColorPickerColorTokens_1.splitColorPickerColorTokens)(attributes.colors);
    return tokens.some((t) => t === trimmed);
}
//# sourceMappingURL=colorPickerRichText.js.map